'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = Switch;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

var _reactProptypeConditionalRequire = require('react-proptype-conditional-require');

var _reactProptypeConditionalRequire2 = _interopRequireDefault(_reactProptypeConditionalRequire);

var _CheckCircleFill = require('@deliveroo/icon-set/react/CheckCircleFill');

var _CheckCircleFill2 = _interopRequireDefault(_CheckCircleFill);

var _CrossCircleFill = require('@deliveroo/icon-set/react/CrossCircleFill');

var _CrossCircleFill2 = _interopRequireDefault(_CrossCircleFill);

var _SpacerElement = require('../../internal/SpacerElement');

var _SpacerElement2 = _interopRequireDefault(_SpacerElement);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styles = {
  'button': 'ccl-5e89f47fbca64e0a',
  'placeholder': 'ccl-2569a9e0385909a7',
  'wrapper': 'ccl-6e188b0ba18d21e4',
  'on': 'ccl-5cc49b7af4dc3879',
  'disabled': 'ccl-479ea612c06de449',
  'tealBackground': 'ccl-ce9385c511d188d8',
  'checkbox': 'ccl-22214f3bc257b4bd'
};


var noop = function noop() {};

var BACKGROUND_COLORS = ['white', 'teal'];

/**
 * A switch for allowing users to turn something on or off.
 */
function Switch(_ref) {
  var _classnames;

  var id = _ref.id,
      name = _ref.name,
      value = _ref.value,
      isOn = _ref.isOn,
      isDisabled = _ref.isDisabled,
      onChange = _ref.onChange,
      withBackground = _ref.withBackground,
      isPlaceholder = _ref.isPlaceholder,
      spacing = _ref.spacing,
      adjacentVerticalSpacing = _ref.adjacentVerticalSpacing,
      adjacentHorizontalSpacing = _ref.adjacentHorizontalSpacing;

  var onClick = function onClick(event) {
    event.preventDefault();

    if (isPlaceholder || isDisabled) {
      return;
    }

    onChange(!isOn);
  };

  var buttonClassNames = (0, _classnames3.default)(styles.button, (_classnames = {}, _defineProperty(_classnames, styles.on, isOn), _defineProperty(_classnames, styles.disabled, isDisabled), _defineProperty(_classnames, styles[withBackground + 'Background'], BACKGROUND_COLORS.includes(withBackground)), _defineProperty(_classnames, styles.placeholder, isPlaceholder), _classnames));

  if (!isPlaceholder && typeof id !== 'string' || id === '') {
    // eslint-disable-next-line no-console
    console.warn('All instances of the `Switch` component should have an "id" prop (and corresponding label for accessibility purposes).'); // eslint-disable-line no-console
  }

  return _react2.default.createElement(
    _SpacerElement2.default,
    {
      element: 'span',
      spacing: spacing,
      adjacentVerticalSpacing: adjacentVerticalSpacing,
      adjacentHorizontalSpacing: adjacentHorizontalSpacing
    },
    _react2.default.createElement(
      'button',
      {
        onClick: onClick,
        className: buttonClassNames,
        role: 'checkbox',
        'aria-checked': isOn,
        type: 'button'
      },
      !isPlaceholder && _react2.default.createElement(
        'div',
        { className: styles.wrapper },
        _react2.default.createElement('input', {
          type: 'checkbox',
          id: id,
          name: name,
          value: value,
          className: styles.checkbox,
          checked: isOn,
          onChange: noop,
          disabled: isDisabled
        }),
        _react2.default.createElement(_Icon2.default, { component: isOn ? _CheckCircleFill2.default : _CrossCircleFill2.default })
      )
    )
  );
}

Switch.displayName = 'Switch';
Switch.propTypes = _extends({
  /** The name of the input this Switch represents. */
  name: (0, _reactProptypeConditionalRequire2.default)(_propTypes2.default.string, function (props) {
    return !props.isPlaceholder;
  }),

  /** The value of the underlying input element. */
  value: (0, _reactProptypeConditionalRequire2.default)(_propTypes2.default.string, function (props) {
    return !props.isPlaceholder;
  }),

  /** The id attribute of the underlying input element. */
  id: (0, _reactProptypeConditionalRequire2.default)(_propTypes2.default.string, function (props) {
    return !props.isPlaceholder;
  }),

  /**
   * An event handler for when the Switch changes. Called with the next isOn
   * state as an argument. The reason this onChange handler is required is
   * because we expect a switch to immediately be applied when pressed and for
   * it to not be part of a form requiring a submit action from the user. This
   * is why the Switch component essentially behaves like a controlled input.
   */
  onChange: (0, _reactProptypeConditionalRequire2.default)(_propTypes2.default.func, function (props) {
    return !props.isPlaceholder;
  }),

  /** Whether the switch component is on. */
  isOn: _propTypes2.default.bool,

  /** Whether the switch component is currently disabled. */
  isDisabled: _propTypes2.default.bool,

  /** When appearing on a particular background colour, override the default
   * appearance of the Switch, to improve colour contrast. */
  withBackground: _propTypes2.default.oneOf(BACKGROUND_COLORS)

}, _SpacerElement2.default.propTypes);

Switch.defaultProps = _extends({
  isOn: false,
  isDisabled: false,
  withBackground: 'white'

}, _SpacerElement2.default.defaultProps);